import request from '@/utils/request'

// 查询企业招聘信息列表
export function listQyzpxx(query) {
  return request({
    url: '/web/xwqy/qyzpxx/list',
    method: 'get',
    params: query
  })
}

// 查询发布页面企业招聘信息
export function listQyzpxxFb(query) {
  return request({
    url: '/web/xwqy/qyzpxx/listFb',
    method: 'get',
    params: query
  })
}

// 新增企业招聘信息
export function addQyzpxx(data) {
  return request({
    url: '/web/xwqy/qyzpxx',
    method: 'post',
    data: data
  })
}

// 查询企业招聘信息详细
export function getQyzpxx(recid) {
  return request({
    url: '/web/xwqy/qyzpxx/' + recid,
    method: 'get'
  })
}

// 修改企业招聘信息
export function updateQyzpxx(data) {
  return request({
    url: '/web/xwqy/qyzpxx/edit',

    method: 'post',
    data: data
  })
}

// 删除企业招聘信息
export function delQyzpxx(recid) {
  return request({
    url: '/web/xwqy/qyzpxx/remove/' + recid,

    method: 'post',
  })
}

// 查询企业招聘信息详情
export function getQyzpxxAndJbxx(recid) {
  return request({
    url: '/web/xwqy/qyzpxx/getQyzpxxAndJbxx' + recid,
    method: 'get'
  })
}
